/**
 * @param {String|jQuery} selector The selector of the elements that trigger scrolling
 */
export default function(selector = null)
{
    const self = this;

    /**
     * The selector of the links that trigger scrolling
     * @type {String}
     */
    self.selector = selector || '.scroll-link';

    /**
     * The body that will scroll
     * @type {jQuery}
     */
    self.$scrollBody = $('html, body');

    /**
     * Space between top of window and top of target element
     * @type {Number}
     */
    self.headroom = 20;

    /**
     * The amount of milliseconds for the scrolling animation
     * @type {Number}
     */
    self.scrollTime = 300;

    /**
     * The scroll easing method
     * @type {String}
     */
    self.scrollEasing = 'swing';

    /**
     * Set the selector for the scroll-triggering links
     * @param  {String} selector
     * @return {void}
     */
    self.setSelector = selector => self.selector = selector;

    /**
     * Set the headroom for the scrolling
     * @param  {Number} headroom
     * @return {void}
     */
    self.setHeadroom = headroom => self.headroom = headroom;

    /**
     * Set the amount of milliseconds of the scrolling animation
     * @param  {Number} scrollTime
     * @return {void}
     */
    self.setScrollTime = scrollTime => self.scrollTime = scrollTime;

    /**
     * Set the easing method of the scrolling animation
     * @param  {String} scrollEasing
     * @return {void}
     */
    self.setScrollEasing = scrollEasing => self.scrollEasing = scrollEasing;

    /**
     * Enable the links that scroll the page
     * @return {void}
     */
    self.enable = () => {
        $('body').on('click', self.selector, event => {
            event.preventDefault();

            // Click can happen on a child element of the scroll link,
            // so make sure to select the scroll link itself
            const $link = $(event.target).closest(self.selector);

            // Get the target to scroll to
            const targetSelector = ($link.data('scrollTo') !== undefined)
                // data-scroll-to attribute takes precedence
                ? $link.data('scrollTo')
                // Or get the hash part of the href attribute
                : $link.attr('href').match(/#.+$/)[0];

            self.scrollToTarget(targetSelector);
        });

        // Scroll to an element, if there is a hash in the URL
        if (window.location.hash !== '') {
            $(window).on('load', () => self.scrollToTarget(window.location.hash));
        }
    };

    /**
     * Scroll to a target element
     * @param  {string|jQuery} element
     * @return {void}
     */
    self.scrollToTarget = element => {
        const $target = $(element);

        // Scroll to the target, if it exists
        if ($target.length) {
            self.$scrollBody.animate({
                scrollTop: $target.offset().top - self.headroom,
            }, {
                duration: self.scrollTime,
                easing: self.scrollEasing,
            });
        }
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/ScrollLinks.js